import { useQuery } from '@tanstack/react-query'

import { settingsKeys } from '../keys'
import { settingsService } from '../services'

import type { GetHotGameFlexMessageResponse } from '../../types'

const useQueryGetFlexHotGame = (id: string) => {
	return useQuery<GetHotGameFlexMessageResponse>({
		queryKey: settingsKeys.flexHotGame(id),
		queryFn: () => settingsService.getFlexHotGame(id),
		enabled: !!id,
	})
}

export default useQueryGetFlexHotGame
